define(
    'viewmodels/secured/subscription/pricing',[
        "viewmodels/controller",
        "providers/dataprovider",
        "viewmodels/ViewModel",
        "i19n!i19n/strings",
        "plugins/router",
        "plugins/dialog",
        "services/service.dialog"
    ],
    function (shell, dataProvider, ViewModel, i19n, router, dialog, dialogService) {
        var $slider = null;

        var vm = new ViewModel({
            i19n: i19n,

            plan: {
                _modal: '',
                code: 7,

                activeUsers: 0,
                activeGuest: 0,
                subsUsers: 0,
                subsGuest: 0,

                priceInfo: 0,
                peopleInfo: 0,
                storageInfo: 0,                
                guestInfo: 0
            },
            
            isManageSubscription: ko.observable(false),
            
            isPerMonth: ko.observable(true),
            isContactUs: ko.observable(false),

            priceInfo: ko.observable(40),
            peopleInfo: ko.observable(2),
            peopleInfoSub: ko.observable('Users'),
            storageInfo: ko.observable(100),
            guestInfo: ko.observable(4),
            guestInfoSub: ko.observable("Guest Users"),
            gbortbInfo: ko.observable('GB'),

            minUsers: 2,
            maxUsers: 50,

            isConfirmPayment: ko.observable(false),
            isShowWarningUsers: ko.observable(false),
            toreducethetotalnumberofusers: ko.observable(i19n.to.toreducethetotalnumberofuserssetsomeusersto),
            isUserExceeded: ko.observable(false),
            isGuestExceeded: ko.observable(false)            
        });

        vm.activate = function (p) {
            vm.isManageSubscription(!(!p || p == false));

            vm.plan._modal = vm.isManageSubscription() ? 'adduser' : 'trial';

            var d = $.Deferred();

            dataProvider.persons
            .getPersons()
            .done(function (data) {

                var psum = { activeGuest: 0, activeUsers: 0 };

                _.map(data, function (itm) {
                    if (itm.personType == 1) {
                        psum.activeGuest++;
                    }
                    if (itm.personType != 1 && itm.personType != 0) {
                        psum.activeUsers++;
                    }
                });

                vm.plan.activeGuest = psum.activeGuest;
                vm.plan.activeUsers = psum.activeUsers;

                dataProvider.settings
                .getUsageSetting()
                .done(function (storage) {
                    //if (window.fileplan && window.fileplan.instanceCode && window.fileplan.instanceCode == "rollie") {
                    //    _test();
                    //} else {
                    //    setSubscriptionCustomerSubs();
                    //}

                    setSubscriptionCustomerSubs();
                    
                });

                function setSubscriptionCustomerSubs() {
                    dataProvider.subscription
                    .getCustomerSubs()
                    .done(function (data) {
                        vm.plan.subsUsers = data.subsMaxUserCount == null || data.subsMaxUserCount == "" || data.subsMaxUserCount < 2 ? 2 : data.subsMaxUserCount;
                        vm.plan.subsGuest = data.subsMaxGuestCount;

                        d.resolve();
                    })
                    .fail(function (e) {                        
                        e.stopPropagation = true;

                        console.error(e);

                        d.reject(e);
                    })
                    .always(function () {
                        if ($slider != null) {
                            initSlider();
                        }
                    });
                }
                function _test() {
                    vm.plan.activeUsers = 12;
                    vm.plan.activeGuest = 27;
                    vm.plan.subsUsers = 13; // never go below 2
                    vm.plan.subsGuest = vm.plan.subsUsers * 2;

                    if ($slider != null) {
                        initSlider();
                    }

                    d.resolve();
                };
            })
            .fail(function (e) {
                console.error(e);

                d.reject(e);
            });

            return d.promise();
        };
        vm.attached = function () {
            initSlider();            
        };
        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };

        vm.confirmPayment = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.isConfirmPayment();
            },
            execute: function (complete) {
                dialog.show("modals/secured/subscription/pricing", [vm.plan]);

                complete();
            }
        });
        vm.contactUs = function () {
            window.location.assign("http://www.fileplan.com/contact-us");
        };

        return vm;

        function initSlider() {
            var ppu = 20;
            var spu = 100;
            var gpu = 2;

            var _guest = parseInt(vm.plan.activeGuest / 2); _guest = vm.plan.activeGuest % 2 > 0 ? _guest + 1 : _guest;
            var _limit = _guest < vm.plan.activeUsers ? vm.plan.activeUsers : _guest;
            var _val = vm.isManageSubscription() ? (_limit < vm.plan.subsUsers ? vm.plan.subsUsers : _limit) : (_limit < vm.plan.activeUsers ? vm.plan.activeUsers : _limit);

            if ($slider == null) {
                $slider = $("#slider").slider({
                    range: "min",
                    value: _val,
                    min: vm.minUsers,
                    max: vm.maxUsers,
                    step: 1,
                    slide: function (event, ui) {
                        var gbortb = (parseInt(ui.value) * spu);

                        vm.peopleInfo(ui.value);
                        vm.priceInfo("$" + (parseInt(ui.value) * ppu));

                        vm.storageInfo(gbortb > 999 ? (gbortb / 1000) : gbortb);
                        vm.gbortbInfo(gbortb > 999 ? "TB" : "GB");

                        vm.guestInfo((parseInt(ui.value) * gpu));
                        vm.isPerMonth(ui.value < vm.maxUsers);
                        vm.isContactUs(!vm.isPerMonth());

                        if (vm.isManageSubscription()) {
                            vm.isConfirmPayment((ui.value >= _limit) && vm.plan.subsUsers != ui.value);
                        } else {
                            vm.isConfirmPayment(ui.value >= (_guest < vm.plan.activeUsers ? vm.plan.activeUsers : _guest));
                        }

                        vm.isShowWarningUsers(ui.value < _limit);
                        vm.toreducethetotalnumberofusers(i19n.to.toreducethetotalnumberofguestorusers);
                        vm.isUserExceeded(vm.plan.activeUsers > parseInt(ui.value));
                        vm.isGuestExceeded(vm.plan.activeGuest > parseInt(ui.value) * 2);                        

                        vm.plan.priceInfo = vm.priceInfo();
                        vm.plan.peopleInfo = vm.peopleInfo();
                        vm.plan.storageInfo = vm.storageInfo() + ' ' + vm.gbortbInfo();
                        vm.plan.guestInfo = vm.guestInfo();

                        if (ui.value == vm.minUsers) {
                            $("#dragme-arrow").css("margin-left", "-5px");
                            $("#dragme-arrow").html("drag &rarr;");
                        }
                        if (ui.value == vm.maxUsers) {
                            $("#dragme-arrow").css("margin-left", "-20px");
                            $("#dragme-arrow").html("&larr; drag");
                        }
                        if (ui.value > vm.minUsers && ui.value < vm.maxUsers) {
                            $("#dragme-arrow").css("margin-left", "-20px");
                            $("#dragme-arrow").html("&larr; drag &rarr;");
                        }

                        setTimeout(function () {
                            var left = ui.handle.style ? ui.handle.style.left : $(ui.handle)[0].style.left;

                            $("#dragme-arrow").css("left", left);

                        }, 100);
                    }
                });
            }

            $slider.slider('option', 'value', _limit);
            $slider.slider('option', 'slide').call($slider, null, { handle: $('.ui-slider-handle', $slider), value: _limit });

            $("#limit").css("width", $("#slider .ui-slider-handle")[0].style.left);

            $slider.slider('option', 'value', _val);
            $slider.slider('option', 'slide').call($slider, null, { handle: $('.ui-slider-handle', $slider), value: _val });

            vm.peopleInfoSub("Users (" + vm.plan.activeUsers + " in use)");
            vm.guestInfoSub("Guests (" + vm.plan.activeGuest + " in use)");
        }
    }
);
